
import React, { useEffect, useRef, useState } from "react";
import "../../assets/css/style_new.css";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import { getProfileQuestion, saveProfileQuestion } from "../../services/apiProfile";
import CircularProgress from "./CircularProgress";
import Validation from "../../commonComponents/Validation";
import { Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // or any other theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { months } from "../../utils/Month";
const ProfileQuestion = (props) => {
    const dateRef = useRef(null);
    const [profileQuest, setProfileQuest] = useState([]);
    const [profileQuestAns, setProfileQuestAns] = useState([]);
    const [profileQuestAnsArr, setProfileQuestAnsArr] = useState([]);
    const [userId, setUserId] = useState('');
    const [basicPercentage, setBasicPercentage] = useState('');
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [isSkipped, setIsSkipped] = useState(false);
    const [selected, setSelected] = useState([]);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [dateError, setDateError] = useState('');
        const [month, setMonth] = useState('');
        const [day, setDay] = useState('');
        const [year, setYear] = useState('');

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userData'));
        setUserId(user._id)
        fetchProfileQuestion(user._id);
    }, [])
    const fetchProfileQuestion = async (id) => {

        const formData = {
            userid: id
        }
        let profileQus = await getProfileQuestion(formData);
        setProfileQuest(profileQus.questions)
        setBasicPercentage(profileQus.basicQuestionPercentage)

    }
    const handleFocus = () => {
        setIsCalendarOpen(true);
    };
    const handleChange = (selectedDate) => {
        let dateSelected = moment(selectedDate).format('YYYY/MM/DD')
        setProfileQuestAns([dateSelected]);
        setTimeout(() => {
            setIsCalendarOpen(false);
        }, 100);
    };
    const openCalendar = () => {
        dateRef.current?.showPicker?.(); // Safe optional chaining
    };
    const formatForInput = (dateStr) => {
        // Convert "03-06-2025" -> "2025-06-03" for input display
        const [day, month, year] = dateStr.split("-");
        return `${month}/${day}/${year}`;
    };

    useEffect(() => {
        const selectedCodes = selected.map(item => item.code);
        setProfileQuestAns(selectedCodes)
    }, [selected]);
    useEffect(() => {
      if (month && day && year) {
        const formattedDob = `${month}/${day.padStart(2, '0')}/${year}`;
        
        // Check if this is a valid date
        const parsedDate = new Date(formattedDob);
        const isValid =
          parsedDate instanceof Date &&
          !isNaN(parsedDate) &&
          parsedDate.getMonth() + 1 === parseInt(month) &&
          parsedDate.getDate() === parseInt(day) &&
          parsedDate.getFullYear() === parseInt(year);
    
        if (isValid) {
          setProfileQuestAns([formattedDob]);
          setDateError(""); // ✅ clear error
        } else {
          setProfileQuestAns([]); // invalid date
          setDateError("Please enter a valid date"); // ❌ invalid
        }
      } else {
        setProfileQuestAns([]);
        setDateError(""); // no error until all fields filled
      }
    }, [month, day, year]);
    const handleSaveQus = async (skip, id, weightage, field, isbasicquestion) => {
        if (dateError) {
            return; // 🔥 immediately stop submission
        }
        if (profileQuestAns !== "" && skip === true || profileQuestAns === "" && skip === true ||
            profileQuestAns !== "" && skip === false) {
            setError(false)
            const formData = {
                userid: userId,
                questionid: id,
                answer: skip ? "" : profileQuestAns,
                weightage: weightage,
                field: field,
                isbasicquestion: isbasicquestion,
                isskipped: skip
            };
            

            let profileQusAnswers = await saveProfileQuestion(formData);
            
            setProfileQuestAns('')
            setMonth('');
            setDay('');
            setYear('')
            setProfileQuest(profileQusAnswers.questions)
            setBasicPercentage(profileQusAnswers.basicQuestionPercentage)

        }
        else {
            setLoader(false);
            if (skip !== true) {
                setError(true);
            }
        }
    }
    const panelHeaderTemplate = (options) => {
        const { className, checkboxElement, filterElement, closeElement   } = options;
        return (
            <div className={className} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {checkboxElement}
                    <label style={{ marginLeft:'-7px', fontSize:'13px' }}>Select All</label>
                </div>
                {filterElement}
                {closeElement}
            </div>
        );
    };
    return (
        <div className="rightbar">
            {profileQuest.map((question, index) => {
                let formattedOption = {}
                let field = "";
                let isbasicquestion = false;
                if (question.type === "basicquestion") {
                    field = question.field;
                    isbasicquestion = true
                }
                if (question.questionControlType === "multiselect") {
                    formattedOption = question.answerOptions.map((item, index) => ({
                        name: item,
                        code: item,
                    }));

                }
                return (
                    <div className="q-container">
                        <div className="headre-main-q">
                            <div className="border-customs">
                                <div className="p-q-thumb" >
                                    
                                    <CircularProgress percentage={question.type === "communityquestion" ? question.completedPercentage[0]?.profileQuestionsCompleted : question.type === "caregiverquestion" ? question.completedPercentage[0]?.profileQuestionsCompleted  : basicPercentage} />
                                </div>
                            </div>
                            <div className="pq-header">
                                <div className="pq-tittle"> Profile Question</div>
                                <span className="pq-community">{question.type === "basicquestion" ? "Basic Question" : question.community[0]?.communityName }</span>

                            </div>

                        </div>
                        <p className="pq-text mb-0">{question.question}</p>


                        <div className="radio-input">

                            <>
                                {question.questionControlType === "multichoice" &&
                                    question.answerOptions.map((opt, index) => (
                                        <label className="label" key={index}>
                                            <div className="option-grp">
                                                <span className="opt-num" >{index + 1}</span>
                                                <p className="text">{opt}</p>
                                            </div>
                                            <input type="radio" id="value-2" name={`question-${question._id}`} value={opt} onChange={() => setProfileQuestAns([opt])}
                                                checked={profileQuestAns?.[0] === opt} />

                                        </label>))}
                                {question.questionControlType === "textfield" &&
                                    <div className="radio-input">
                                        <Form.Group className="" >
                                            <Form.Control as="textarea" rows={1}
                                                value={profileQuestAns}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    const dataType = question.answerDataType;

                                                            // Simple per-type validation
                                                            let isValid = true;
                                                            if (dataType === "number") isValid = /^[0-9]*$/.test(newValue);
                                                            else if (dataType === "zipcode") isValid = /^[0-9]{0,5}$/.test(newValue);
                                                            else if (dataType === "string") isValid = /^[a-zA-Z\s.,'-]*$/.test(newValue);
                                                            if (!isValid) return;
                                                    setProfileQuestAns([e.target.value])}} />
                                        </Form.Group>
                                    </div>}
                                {question.questionControlType === "date" &&
                                <>
                                <div className="dob-splitter mt-3">
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            
                                            <Form.Select  aria-label="Default select example" placeholder="Month"
                                                value={month}
                                                onChange={(e) => setMonth(e.target.value)}>
                                                {months.map((m) => (
                                                <option key={m.value} value={m.value}>
                                                    {m.label}
                                                </option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                    </div>
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            <input type="number" className="form-control"
                                            placeholder="Day"
                                            value={day}
                                            
                                             onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '') setDay('');
                                                else {
                                                const num = Math.min(Math.max(parseInt(val), 1), 31);
                                                setDay(num.toString());
                                                }
                                            }}
                                            min="1"
                                            max="31" />
                                        </div>
                                    </div>
                                    <div className="splitter-itm">
                                        <div className="form-input">
                                            <input  type="number" className="form-control"
                                            placeholder="Year"
                                            value={year}
                                            
                                           onChange={(e) => {
                                                // Just update the raw text
                                                setYear(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value;
                                                if (val === '') return;
                                                const num = Math.min(Math.max(parseInt(val), 1900), 2200);
                                                setYear(num.toString());
                                            }}
                                            min="1900"
                                            max={new Date().getFullYear()}/>
                                        </div>
                                    </div>
                                </div>
                                    <div className="radio-input-date d-none">
                                        
                                        <Datetime
                                            dateFormat="MM/DD/YYYY"
                                            inputProps={{
                                                onFocus: handleFocus,
                                                placeholder: 'e.g. 01/21/2025'
                                            }}
                                            timeFormat={false}
                                            open={isCalendarOpen}
                                            value={profileQuestAns?.[0] || ''}
                                            onChange={handleChange}

                                       

                                        />

                                    </div></>}
                                {question.questionControlType === "multiselect" &&
                                    <div className="radio-input">
                                        <MultiSelect optionLabel="name"
                                            maxSelectedLabels={3}
                                            className=""
                                            placeholder="Choose..."
                                            options={formattedOption}
                                            value={selected}
                                            onChange={(e) => setSelected(e.value)} 
                                            showSelectAll      
                                            panelHeaderTemplate={panelHeaderTemplate} />
                                    </div>
                                }
                            </>
                        </div>


                        {/* ))} */}
{dateError && <Validation message={'Please enter a valid date'} />}
                        {error && <Validation message={'Please choose an answer'} />}

                        <div className="d-flex justify-content-center pq-buttons">
                            <button type="button" className="pq-skip btncancel skip m-0" onClick={() => handleSaveQus(true, question._id, question.weightage, field, isbasicquestion)} >
                                Skip
                            </button>

                            <button className="pq-next Saveandnext cofim m-0" onClick={() => handleSaveQus(false, question._id, question.weightage, field, isbasicquestion)}> Confirm</button>
                        </div>
                    </div>
                )
            })}

            {props.type === "peoplelikeme" &&
                <div className="text1 mt-4 ">
                    <p className="text-left box1-text" ><Link onClick={() => window.location.reload()}>You have  given more Profile information. Click to Refresh and find more relevant post</Link></p>
                </div>}



        </div>
    );
};

export default ProfileQuestion;
